import script from "./AboutPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutPage.vue?vue&type=script&setup=true&lang=js"

import "./AboutPage.vue?vue&type=style&index=0&id=45f987da&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.18_vue@3.5.18_webpack@5.100.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45f987da"]])

export default __exports__